import { SET_REASSIGNED_ITEMS_TO } from "../reducers/reassignedItemsTo";
import { Dispatch } from "../types/types";

export const SetReassignItemsToUser =
    (selectedUserId: number) =>
    (dispatch: Dispatch): void => {
        dispatch({ type: SET_REASSIGNED_ITEMS_TO, selectedUser: selectedUserId });
    };
